import React, { useState } from 'react';

import { useContentRequirementsContext } from 'src/application/features/RestrictNavigation/ContentRequirementsProvider';
import { useOnMount } from 'src/application/hooks/useOnMount';

import { StudentWidgetWrapper } from '../../../components/Widgets/StudentWidgetWrapper';
import { useGetMultipleAssetUrls } from '../../hooks/useGetMultipleAssetUrls';
import { ExistingStudentWidgetProps } from '../Widget';
import { ImageCarouselWidget, WidgetType } from '@ael/core-api';
import { ImageCarousel } from '@ael/shared-components-library';

export const ImageCarouselWidgetComponent: React.FC<ExistingStudentWidgetProps> = ({ widget }) => {
  const imageCarouselWidget = widget as ImageCarouselWidget;
  const data = imageCarouselWidget.value.data;

  const { getAssetDataForIndex } = useGetMultipleAssetUrls(
    widget._id,
    WidgetType.imageCarousel,
    data.images.map((x) => x.assetId)
  );

  const { submitWidget, fulfilled } = useContentRequirementsContext();
  const fulfillCurrentWidget = () => submitWidget(widget, true);

  const [, setViewedImages] = useState<boolean[]>(new Array(data.images.length).fill(true, 0, 1).fill(false, 1));

  useOnMount(() => {
    if (fulfilled === false && imageCarouselWidget.value.properties.isRequired && data.images.length === 1) {
      fulfillCurrentWidget();
    }
  });

  const handleIndexChange = (index: number) => {
    if (fulfilled === false && imageCarouselWidget.value.properties.isRequired) {
      setViewedImages((prev) => {
        const newViewedImages = [...prev];
        newViewedImages[index] = true;
        if (newViewedImages.every((viewed) => viewed)) {
          fulfillCurrentWidget();
        }
        return newViewedImages;
      });
    }
  };

  return (
    <StudentWidgetWrapper>
      <ImageCarousel
        onIndexChange={handleIndexChange}
        images={data.images.map((image, index) => {
          const imageData = getAssetDataForIndex(index);
          return {
            src: imageData?.url ?? '',
            caption: image.caption,
            imageWidth: imageData?.dimensions?.width,
            imageHeight: imageData?.dimensions?.height,
          };
        })}
      />
    </StudentWidgetWrapper>
  );
};
